<div class="footer bg-footer" *ngIf="subtitles.downloaded">

    <a href="https://techsterowniki.pl"
       target="_blank"
       class="footer__address"
       *ngIf="showDefaultFooter()">
        <div class="footer__inner">
            <img src="/assets/img/logo_tech_vector.svg"
                 alt=""
                 class="footer__logo--tech">
            <div class="footer__text color-light font-13">
                <span> © Copyright by </span>
                <span>{{ subtitles.language === 'pl' ? 'TECH Sterowniki' : 'TECH Controllers' }}</span>
                <span> {{ fullYear }}</span>
            </div>
        </div>
    </a>

    <div class="footer__inner" *ngIf="parameters.urlCompany === 'jawo'">
        <img [src]="'./assets/img/logo_jawo_white.png'" alt="" class="footer__logo--jawo">
    </div>

    <div class="footer__inner" *ngIf="parameters.urlCompany === 'roth'">
        <img [src]="'./assets/img/roth_white.svg'" alt="" class="footer__logo--roth">
    </div>

    <div class="footer__inner" *ngIf="parameters.urlCompany === 'polypipe'">
        <img [src]="'./assets/img/logo_polypipe_white.png'" alt="" class="footer__logo--polypipe">
    </div>

    <a href="http://www.infrarotheizung-elias.com"
       target="_blank"
       class="footer__address footer__text color-light font-13"
       *ngIf="parameters.urlCompany === 'Elias'">
        <span> ELIAS. Die Heizung. </span> <span>{{ fullYear }}</span>
    </a>

</div>
